class ReactFilterRelationship extends React.Component{

    constructor(props) {
        super(props);
        ModulesMixinsOutsideClick._composite(this);
        this.state = {
            isActive: false,
            isExpanded: false,
        }
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {

        var personRelationTypeId = this.refs.combo.getValues();
        var personId = this.refs.personCombo?this.refs.personCombo.getValues():null;

        this.setState({isActive: personRelationTypeId || personId});

        return {
            person_relation_type_id:personRelationTypeId,
            person_id: personId
        };
    }

    clearFilter() {
        this.clearValues();
        if(this.props.loadGrid) {
            setTimeout( function(){
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.refs.combo.clearValues();

        if(this.refs.personCombo){
            this.refs.personCombo.clearValues();
        }

        this.setState({
            isActive: false
        });
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.person_relation_type_id || values.person_id){
            
            if(values.person_relation_type_id) {
                this.refs.combo.setValues({
                    value: values.person_relation_type_id
                })
            }
            
            if(values.person_id){
                this.refs.personCombo.setValues({
                    value: values.person_id
                })
            }

            this.setState({
                isActive:true
            })
            
        }else{
            this.clearValues();
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if(event.target.dataset.button == "apply"){
            this.props.applyFilters();
        }
        if(event.target.dataset.button == "clear"){
            this.props.clearFilters();
        }
    }

    outsideClickHandle(e) {
        this.setState({
            isExpanded: false
        });
    }

    render() {
        var props = this.props;
        var state = this.state;
        var relationTypeId = this.props.settings.person_relation_type_id;

        var comboConfig = {
            ref:'combo',
            label: this.props.label,
            url: SS.route('People','PersonRelationTypes','getAll'), // Optional if you use the records property
            value:relationTypeId,
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid
        }

        var hasLoggedinPerson = false;
        var hasPersonIds = false;

        if(props.settings){
            if(parseInt(props.settings.logged_in_person)){
                hasLoggedinPerson = true;
            }

            if(props.settings.person_id){
                hasPersonIds = true;
            }
        }

        var isMixed = !hasLoggedinPerson && !hasPersonIds;

        if(isMixed){
            delete comboConfig.applyFilters;
            delete comboConfig.clearFilters;
            delete comboConfig.loadGrid;
            comboConfig.hideButton = true;
        }

        var combo = React.createElement(ReactFilterCombo,comboConfig);

        if(!isMixed){
            return combo;
        }else{

            var personComboConfig = {
                ref: 'personCombo',
                label: this.props.label,
                url: SS.route('People', 'People', 'getAll'),
                paginated: true,
                idField: 'id',
                displayField: 'fullname',
                minChars: this.props.settings.min_chars,
                hideButton: true,
                urlParams: {
                    limit: 10,
                    simple: true
                },
            }

            var personCombo = React.createElement(ReactFilterCombo,personComboConfig);

            var holderCls = 'btn-group custom-dropdown-wrapper accordion-wrapper';
            if(state.isActive){
                holderCls += ' active';
            }
            if(state.isExpanded){
                holderCls += ' expanded';
            }

            var buttons = null;
            if(this.props.applyFilters && this.props.clearFilters){
                buttons = (
                    <div className="grid-filter-actions">
                        <a onClick={this.handleFilterButtons.bind(this)} data-button="apply" className="btn btn-primary apply-filter" role="button">Apply</a>
                        <a onClick={this.handleFilterButtons.bind(this)} data-button="clear" className="btn btn-link clear-filter" role="button">Reset</a>
                    </div>
                );
            }

            return (
                <div className={holderCls}>
                    <div className="custom-dropdown-button">
                        <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle" ref="outside_click_trigger" onClick={this.togglePopup.bind(this)} data-toggle="custom-dropdown" aria-haspopup="true" aria-expanded="false">
                            {props.label}
                        </button>
                    </div>
                    <div className="custom-dropdown-clear-button">
                        <button type="button" className="btn btn-primary clear-filter" onClick={this.clearFilter.bind(this)}><i/></button>
                    </div>
                    <div className={"card custom-dropdown-popup "+(state.paginated?" paginated":"") +(state.wide?" wide":"")} ref="outside_click_content">
                        <div className="card-block" id={"relationshipAccordion"+props.id} role="tablist" >
                            <div className="panel">
                                <div className="content">
                                    <button className="btn accordion-btn" role="tab" data-toggle="collapse" data-target={"#relationshipFilter"+props.id} href={"#relationshipFilter"+props.id}>Relationships</button>
                                </div>
                                <div id={"relationshipFilter"+props.id} className="collapse show in" role="tabpanel" data-parent={"#relationshipAccordion"+props.id}>
                                    {combo}
                                </div>
                            </div>
                            <div className="panel">
                                <div className="content">
                                    <button className="btn accordion-btn collapsed" role="tab" data-toggle="collapse" data-target={"#personFilter"+props.id} href={"#personFilter"+props.id}>People</button>
                                </div>
                                <div id={"personFilter"+props.id} className="collapse" role="tabpanel" data-parent={"#relationshipAccordion"+props.id}>
                                    {personCombo}
                                </div>
                            </div>
                            <div className="panel">
                                {buttons}
                            </div>
                        </div>
                    </div>
                </div>
            );

        }

    }
}

ReactFilterRelationship.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};
